/* eslint-disable react-hooks/exhaustive-deps */
import AuthBase from "../AuthBase";
import {Avatar, Stack, useTheme} from "@mui/material";
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import {useContext, useRef, useState} from "react";
import Typography from "@mui/material/Typography";
import EditIcon from '@mui/icons-material/Edit';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ConfigContext from "../../context/ConfigContext";
import DinoDialog from "../../components/Dialog";
import CategoryData from "./CategoryData";
import Button from "@mui/material/Button";
import CircleButton from "../../components/CircleButton";
import {useNavigate} from "react-router";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import Loading from "../../components/Loading";
import {truncateText} from "../../utils/misc";
import NoItems from "../../components/NoItems";
import useCategoryQueries from "../../hooks/queries/useCategoryQueries";
import {useSnackbar} from "notistack";
import BlurhashAvatar from "../../components/BlurhashAvatar";


const Category = ({id, name, description, image, imageBlurhash, numberOfServices, edit, destroy}) => {
    const theme = useTheme()
    const navigate = useNavigate()
    const {baseUrl} = useContext(ConfigContext)
    const imageSrc =
        image && image.startsWith("http") ? image : baseUrl + image;

    return <Stack sx={{flexDirection: {xs: 'column', sm: 'column', md: 'row'}}} spacing={2}
                  style={{width: '100%', justifyContent: 'space-between'}}>
        <Stack direction='row' spacing={2}>
            <BlurhashAvatar
                src={imageSrc}
                blurhash={imageBlurhash}
                size={60}
                sx={{
                    border: "2px solid",
                    borderColor: theme.palette.primary[200],
                    alignSelf: "center",
                }}
            />
            <div style={{alignSelf: 'center'}}>
                <Typography variant="subtitle1" style={{color: theme.palette.primary[600]}}>{name}</Typography>
                <Typography variant="body2" style={{color: '#536B74'}}>{truncateText(description, 30)}</Typography>
            </div>
        </Stack>

        <Stack spacing={1} direction='row' sx={{display: {xs: 'none', sm: 'none', md: 'flex'}}}>
            <Typography variant='button' align='center' noWrap sx={{
                color: theme.palette.primary[600],
                alignSelf: 'center'
            }}>{numberOfServices} szolgáltatás</Typography>
            <CircleButton icon={<DeleteRoundedIcon/>} onClick={destroy}/>
            <CircleButton icon={<EditIcon/>} onClick={edit}/>
            <CircleButton icon={<KeyboardArrowRightIcon/>} onClick={() => navigate(`/categories/${id}`)} inverted/>
        </Stack>

        <Stack spacing={1} sx={{display: {xs: 'flex', sm: 'flex', md: 'none'}}}>
            <Button variant='outlined' endIcon={<DeleteRoundedIcon/>} onClick={destroy}>Törlés</Button>
            <Button variant='outlined' endIcon={<EditIcon/>} onClick={edit}>Szerkesztés</Button>
            <Button variant='contained' endIcon={<KeyboardArrowRightIcon/>}
                    onClick={() => navigate(`/categories/${id}`)}>Megnyitás</Button>
        </Stack>
    </Stack>
}

const Categories = () => {
    const [current, setCurrent] = useState(1)
    const [editOpen, setEditOpen] = useState(false)
    const [newOpen, setNewOpen] = useState(false)
    const [deleteOpen, setDeleteOpen] = useState(false)
    const navigate = useNavigate()
    const {enqueueSnackbar} = useSnackbar()

    const {categoryBusinessQuery, createCategoryMutation, updateCategoryMutation, deleteCategoryMutation} = useCategoryQueries()
    const {data: categories, isPending: categoriesLoading} = categoryBusinessQuery

    const serviceForm = useRef(null)

    const getCategory = (id) => categories.find(c => c.id === id)

    const newCategory = data => createCategoryMutation.mutate(data, {
        onSuccess: response => navigate(`/categories/${response.id}`),
        onError: errors => {
            errors.errors.forEach(err => {
                if (err.field) {
                    enqueueSnackbar(`${err.message} - ${err.field}`, {variant: 'error'});
                } else {
                    enqueueSnackbar(err.message, {variant: 'error'});
                }
            });
        }
    })

    const editCategory = data => updateCategoryMutation.mutate({ id: current, data }, {
        onError: errors => {
            errors.errors.forEach(err => {
                if (err.field) {
                    enqueueSnackbar(`${err.message} - ${err.field}`, {variant: 'error'});
                } else {
                    enqueueSnackbar(err.message, {variant: 'error'});
                }
            });
        }
    })

    const removeCategory = id => deleteCategoryMutation.mutate(id)

    const buttons = [{
        name: 'Új kategória hozzáadása',
        props: {
            variant: 'contained',
            size: 'large',
            endIcon: <AddCircleOutlinedIcon/>,
            onClick: () => {
                setNewOpen(true)
            }
        }
    }]

    const filterButtons = [
        {
            name: 'Új kategória',
            props: {
                variant: 'contained',
                size: 'small',
                endIcon: <AddCircleOutlinedIcon/>,
                onClick: () => {
                    setNewOpen(true)
                }
            }
        }
    ]

    if (categoriesLoading || createCategoryMutation.isPending || updateCategoryMutation.isPending || deleteCategoryMutation.isPending) return <Loading isLoading />

    return <AuthBase label='Kategóriák' buttons={buttons} filterButtonsMobile={filterButtons}>
        <div className="main">
            {categories?.length === 0 ? <NoItems
                    title='Nincsenek kategóriák'
                    description='Adj hozzá új kategóriát a fenti gombra kattintva! 👆'
                />
                :
                <Stack>
                    <Typography variant='subtitle2' color='#536B74' gutterBottom>
                        {categories?.length} szolgáltatás kategória
                    </Typography>
                    <div className="white-card">
                        <Stack spacing={2}>
                            {categories?.map((c, i) =>
                                <Category
                                    key={`category_${i}`}
                                    name={c.name}
                                    id={c.id}
                                    description={c.description}
                                    blur={c.blur}
                                    image={c.picture}
                                    imageBlurhash={c.blurhash}
                                    numberOfServices={c.number_of_services}
                                    edit={() => {
                                        setCurrent(c.id)
                                        setEditOpen(true)
                                    }}
                                    destroy={() => {
                                        setCurrent(c.id)
                                        setDeleteOpen(true)
                                    }}/>
                            )}
                        </Stack>
                    </div>
                </Stack>}
        </div>

        <DinoDialog open={newOpen}
                    title='Új kategória hozzáadása'
                    subtitle='Hozz létre egyedi kategóriákat és ahhoz tartozó szolgáltatásokat egyszerűen. Add meg a kategória nevét és leírását!'
                    actions={<>
                        <Button variant='outlined' style={{padding: 15}} onClick={() => setNewOpen(false)}>Mégsem</Button>
                        <Button variant='contained' style={{padding: 15}} onClick={() => {
                            const data = serviceForm.current.getData()
                            if (!data) return
                            if (Object.keys(data).length > 0) {
                                newCategory(data)
                                setNewOpen(false)
                            }
                        }} endIcon={<AddCircleOutlinedIcon/>}>Hozzáadás</Button>
                    </>}
                    handleClose={() => setNewOpen(false)}>
            <CategoryData reference={serviceForm}/>
        </DinoDialog>

        <DinoDialog open={editOpen}
                    title={`${getCategory(current)?.name} kategória szerkesztése`}
                    subtitle='Add meg a kategória nevét és leírását!'
                    actions={<>
                        <Button variant='outlined' style={{padding: 15}} onClick={() => setEditOpen(false)}>Mégsem</Button>
                        <Button variant='contained' style={{padding: 15}} onClick={() => {
                            const data = serviceForm.current.getData()
                            if (typeof data?.picture === 'string') delete data['picture'] // Ugh... If the picture is already uploaded leave it alone
                            if (!data) return
                            if (Object.keys(data).length > 0) {
                                editCategory(data)
                                setEditOpen(false)
                            }
                        }} endIcon={<EditIcon/>}>Szerkesztés</Button>
                    </>}
                    handleClose={() => setEditOpen(false)}>
            <CategoryData obj={getCategory(current)} reference={serviceForm}/>
        </DinoDialog>

        <DinoDialog open={deleteOpen}
                    title={`Biztosan kitörli ezt: ${getCategory(current)?.name}`}
                    subtitle='Az összes hozzá tartozó szolgáltatás és foglalás törlődni fog!'
                    actions={<>
                        <Button variant='outlined' style={{padding: 15}} onClick={() => setDeleteOpen(false)}>Mégsem</Button>
                        <Button variant='contained' style={{padding: 15}} onClick={() => {
                            setDeleteOpen(false)
                            removeCategory(current)
                        }} endIcon={<DeleteRoundedIcon/>}>Törlés</Button>
                    </>}
                    handleClose={() => setDeleteOpen(false)}>
        </DinoDialog>

    </AuthBase>
}

export default Categories